frontApp.lazyLoad.init();
frontApp.tooltip.init();
frontApp.dialog.init();
frontApp.burger.init();
frontApp.userMenu.init();
frontApp.menu.init();
frontApp.search.init();
frontApp.promoSlider.init();
frontApp.imagesSlider.init();
frontApp.partnersSlider.init();
frontApp.buttonScroll.init();
frontApp.productGallery.init();
frontApp.itemsSlider.init();
frontApp.reviews.init();
frontApp.reviewsPhotosSlider.init();
frontApp.reviewCreate.init();
frontApp.reviewsSorting.init();
frontApp.share.init();
frontApp.favourite.init();
frontApp.jsRoll.init();
frontApp.cart.init();
frontApp.b_popup.init();
frontApp.orderItemToggle.init();
frontApp.checkLogout.init();
frontApp.popupMssage.init();
